import React from 'react';
import { TextField } from '@mui/material';

const CustomTextField = ({ label, name, value, onChange, fullWidth }) => {
  return (
    <TextField
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      variant="outlined"
      
    />
  );
};

export default CustomTextField;
